import React, { useContext } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify'; // Optional: for showing errors or success messages
import { CommonPage } from '../components/common/CommonPage';
import { CmsContext } from '../context/CmsContext'

export const Terms = () => {
  const { cmsData, loading } = useContext(CmsContext);
  return (
    <div>
        <CommonPage pageTitle={"Terms and conditions "} ckData={cmsData.terms} loading={loading}/>
    </div>
  )
};
